import c from "./SectionBox.module.scss";
import { cn } from "../../lib/utils";

function SectionBox({ title, children, layout, className }) {
	return (
		<div className={cn(c.main_section_box, layout && c[layout], className?.container)}>
			{title && (
				<div className={c.main_intro}>
					<h2 className={c.intro}>{title}</h2>
				</div>
			)}
			<div className={cn(c.main_box, className?.content)}>{children}</div>
		</div>
	);
}

export default SectionBox;
